import { render, staticRenderFns } from "./CustomCardList.vue?vue&type=template&id=576c9144"
import script from "./CustomCardList.vue?vue&type=script&lang=js"
export * from "./CustomCardList.vue?vue&type=script&lang=js"
import style0 from "./CustomCardList.vue?vue&type=style&index=0&id=576c9144&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports